import { render, staticRenderFns } from "./MediaFile.vue?vue&type=template&id=bbe05488&scoped=true&"
import script from "./MediaFile.vue?vue&type=script&lang=js&"
export * from "./MediaFile.vue?vue&type=script&lang=js&"
import style0 from "./MediaFile.vue?vue&type=style&index=0&id=bbe05488&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe05488",
  null
  
)

export default component.exports